import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { EyeOff, Users } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function DiagnosticoSection() {
  return <section className="py-24 bg-pure-black relative border-t border-white/5" data-id="element-98">
      <div className="container mx-auto px-6" data-id="element-99">
        <div className="text-center mb-16" data-id="element-100">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-electric-yellow mb-4 uppercase tracking-wide" data-id="element-101">
            El Diagnóstico
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-emerald-glow mx-auto rounded-full" data-id="element-102" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-103">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="bg-dark-gray rounded-xl p-8 border border-white/10 relative overflow-hidden group hover:border-electric-yellow/30 transition-colors duration-300" data-id="element-104">
            <div className="absolute top-0 left-0 w-1 h-full bg-electric-yellow opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-105" />
            <div className="bg-pure-black w-14 h-14 rounded-full flex items-center justify-center mb-6 border border-white/10 group-hover:border-electric-yellow/50 transition-colors" data-id="element-106">
              <EyeOff className="w-7 h-7 text-electric-yellow" data-id="element-107" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-108">
              Síndrome del Taller Invisible
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-109">
              Los clientes pasan por enfrente pero buscan en Google y terminan
              en el taller de la competencia.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="bg-dark-gray rounded-xl p-8 border border-white/10 relative overflow-hidden group hover:border-electric-yellow/30 transition-colors duration-300" data-id="element-110">
            <div className="absolute top-0 left-0 w-1 h-full bg-electric-yellow opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-111" />
            <div className="bg-pure-black w-14 h-14 rounded-full flex items-center justify-center mb-6 border border-white/10 group-hover:border-electric-yellow/50 transition-colors" data-id="element-112">
              <Users className="w-7 h-7 text-electric-yellow" data-id="element-113" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-114">
              Baja Retención
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-115">
              No tienes un sistema que le recuerde al cliente sus cambios de
              aceite o frenos automáticamente.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}